var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isReady)?_c('operation-report-show-body-form-item-image',_vm._b({on:{"download":_vm.onDownload,"delete":_vm.onDelete,"upload":_vm.uploadTempImage,"change":_vm.onChange,"show-dialog":_vm.showUploadDialog,"close-dialog":_vm.closeUploadDialog}},'operation-report-show-body-form-item-image',_vm.formData,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }